import Checkbox, { CheckboxWithLabelProps } from './Checkbox';

export type { CheckboxWithLabelProps };
export default Checkbox;
